// partnerService.ts
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase/firebase'; // Path to your Firebase config
import { deliveryPartner } from '../model/partnerModels';
import { restaurantPartner } from '../model/restaurantModels';
import { RESTAURANT_COLLECTION, flattenRestaurant } from '../utills/restaurantAdapter';

// Fetch all restaurant partners from the new collection, flattened to the
// shape the screens expect. Optional branchId filter.
export const fetchRestaurants = async (branchId?: string): Promise<restaurantPartner[]> => {
  try {
    const colRef = collection(db, RESTAURANT_COLLECTION);
    const q = branchId ? query(colRef, where('branchId', '==', branchId)) : colRef;

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => flattenRestaurant(doc.id, doc.data()) as restaurantPartner);
  } catch (error) {
    console.error('Error fetching restaurants:', error);
    return [];
  }
};

// Fetch delivery partners, optionally filtered by storeid
export const fetchDeliveryPartners = async (storeId?: string): Promise<deliveryPartner[]> => {
  try {
    const colRef = collection(db, 'deliveryPartner');
    const q = storeId ? query(colRef, where('storeid', '==', storeId)) : colRef;

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => {
      const data = doc.data() as deliveryPartner;
      return {
        partnerId: doc.id,
        ...data,
      };
    });
  } catch (error) {
    console.error('Error fetching delivery partners:', error);
    return [];
  }
};
